/*
 * /therapy/session/$therapySessionId (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import {
	Container,
	Divider,
	Page,
	PageHeader,
	Skeleton,
} from "@psychology/react-ui"
import { capitalizeFirstLetter } from "@psychology/utils"
import { ArrowLeft } from "lucide-react"
import { TherapySessionForm } from "../../../features/therapy/components/therapy-session-form"
import { trpc } from "../../../trpc"
import { authPageLoader } from "../../../utils/auth.utils"

export const Route = createFileRoute("/therapy/session/$therapySessionId")({
	component: TherapySessionPage,
	loader: authPageLoader,
})

function TherapySessionPage() {
	const { therapySessionId } = Route.useParams()
	const { user } = Route.useLoaderData()

	const { data: therapySession, isLoading } =
		trpc.therapySession.getByFilter.useQuery({
			where: { id: therapySessionId },
		})

	if (isLoading) {
		return (
			<Page centerVertical={false}>
				<Container
					className={"items-center"}
					width={"xl"}
					padding={"lg"}
					gap={"sm"}
				>
					<Skeleton className={"h-8 w-64"} />
					<Divider />
					<div
						className={
							"flex w-full flex-col items-center justify-center gap-3 py-6"
						}
					>
						<Skeleton className={"h-10 w-full max-w-[500px]"} />
					</div>
				</Container>
			</Page>
		)
	}

	return (
		<Page centerVertical={false}>
			<Container
				className={"items-center"}
				width={"xl"}
				padding={"lg"}
				gap={"sm"}
			>
				<PageHeader
					title={capitalizeFirstLetter(
						therapySession?.title || "New Therapy Session",
						true,
					)}
					left={{
						href: "/therapy/session",
						label: "Back",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<div className={"w-full py-6"}>
					<TherapySessionForm
						id={therapySessionId}
						therapySession={therapySession || undefined}
						userId={user.id}
					/>
				</div>
			</Container>
		</Page>
	)
}
